import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Success.css';

function Success() {
  const navigate = useNavigate();
  const location = useLocation();
  const [order, setOrder] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  useEffect(() => {
    // If order is passed via navigation state
    if (location.state) {
      setOrder(location.state);

      // Save to backend
      fetch(`${API_BASE_URL}/confirm-order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(location.state),
      })
        .then(res => res.json())
        .then(data => {
          console.log('Order saved to backend:', data);
        })
        .catch(err => console.error('Error saving order:', err));
    } else {
      // Fallback: Try getting from localStorage
      const orders = JSON.parse(localStorage.getItem('orders')) || [];
      if (orders.length > 0) {
        const latestOrder = orders[orders.length - 1];
        setOrder(latestOrder);

        // Save to backend
        fetch(`${API_BASE_URL}/confirm-order`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(latestOrder),
        })
          .then(res => res.json())
          .then(data => {
            console.log('Order saved to backend:', data);
          })
          .catch(err => console.error('Error saving order:', err));
      }
    }
  }, [location.state]);

  return (
    <div className="success-container">
      <div id="printable">
        <h2>🎉 Order Confirmed!</h2>
        <p>Thank you for your purchase.</p>

        {order ? (
          <div className="receipt-box">
            <h3>Order Receipt</h3>
            <p><strong>Order ID:</strong> {order.id}</p>
            <p><strong>Date:</strong> {new Date(order.date).toLocaleString()}</p>
            <p><strong>Name:</strong> {order.customer?.name}</p>
            <p><strong>Email:</strong> {order.customer?.email}</p>
            <p><strong>Mobile:</strong> {order.customer?.mobile}</p>
            <hr />
            <p><strong>Amount Paid:</strong> ₹{(order.amount).toFixed(2)}</p>
          </div>
        ) : (
          <p>No order found. Please go back and place an order.</p>
        )}
      </div>

      <button className="back-to-menu" onClick={() => navigate('/menu')}>
        ⬅ Back to Menu
      </button>

      {order && (
        <button className="print-receipt" onClick={() => window.print()}>
          🖨️ Print / Save as PDF
        </button>
      )}
    </div>
  );
}

export default Success;
